import React from "react";
import CardFormPage from "./CardFormPage";

function CardAddPage() {
  return <CardFormPage mode="create" />;
}

export default CardAddPage;
